import { render, staticRenderFns } from "./PRoundButton.vue?vue&type=template&id=307601de&scoped=true&"
import script from "./PRoundButton.vue?vue&type=script&lang=js&"
export * from "./PRoundButton.vue?vue&type=script&lang=js&"
import style0 from "./PRoundButton.vue?vue&type=style&index=0&id=307601de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307601de",
  null
  
)

export default component.exports